import type { FC } from "react";
import { SideNavContainer } from "./nav/SideNav.style";

const AdsComponent:FC = () => {

return(
    <SideNavContainer/>
)
}

export default AdsComponent;